import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
var NglDatepickerWeekdays = (function () {
    function NglDatepickerWeekdays() {
        this.weekdays = [];
    }
    NglDatepickerWeekdays.prototype.ngOnChanges = function (changes) {
        this.weekdays = [];
        for (var i = 0; i < 7; i++) {
            var offset = (this.firstDayOfWeek + i) % 7;
            this.weekdays.push({
                id: "weekday-" + i,
                label: this.dayNamesShort[offset],
                title: this.dayNamesLong[offset],
            });
        }
    };
    NglDatepickerWeekdays.decorators = [
        { type: Component, args: [{
                    selector: 'tr[nglWeekdays]',
                    template: "\n    <th *ngFor=\"let day of weekdays\" [id]=\"day.id\" scope=\"col\"><abbr [title]=\"day.title\">{{day.label}}</abbr></th>\n  ",
                    changeDetection: ChangeDetectionStrategy.OnPush,
                },] },
    ];
    /** @nocollapse */
    NglDatepickerWeekdays.ctorParameters = function () { return []; };
    NglDatepickerWeekdays.propDecorators = {
        'dayNamesShort': [{ type: Input },],
        'dayNamesLong': [{ type: Input },],
        'firstDayOfWeek': [{ type: Input },],
    };
    return NglDatepickerWeekdays;
}());
export { NglDatepickerWeekdays };
//# sourceMappingURL=weekdays.js.map